export const ausbildungOptions = ["Pflege", "Hotellerie", "Bäckerei", "IT", "Erzieher:in"];

export const ausbildungOptionDetails = {
  Pflege: {
    image: "/ausbildung-pflege.png",
    availability: "open",
    action: "apply",
    en: { title: "Nursing", description: "Vocational training in healthcare, patient support, and elderly care." },
    de: { title: "Pflege", description: "Ausbildung im Gesundheitswesen sowie in der Betreuung von Patienten und älteren Menschen." },
    ar: { title: "التمريض", description: "تدريب مهني في الرعاية الصحية ودعم المرضى ورعاية كبار السن." },
  },
  Hotellerie: {
    image: "/ausbildung-hotellerie.png",
    availability: "open",
    action: "apply",
    en: { title: "Hospitality", description: "Vocational training in hotels, guest service, organization, and tourism." },
    de: { title: "Hotellerie", description: "Ausbildung in Hotels, Gästeservice, Organisation und Tourismus." },
    ar: { title: "الفندقة", description: "تدريب مهني في الفنادق وخدمة الضيوف والتنظيم والسياحة." },
  },
  Bäckerei: {
    image: "/ausbildung-baeckerei.png",
    availability: "soon",
    action: "interest",
    en: { title: "Bakery", description: "Vocational training in bakery craft, food production, and practical work." },
    de: { title: "Bäckerei", description: "Ausbildung im Backhandwerk, in der Lebensmittelproduktion und in der praktischen Arbeit." },
    ar: { title: "المخبوزات", description: "تدريب مهني في صناعة المخبوزات والإنتاج الغذائي والعمل العملي." },
  },
  IT: {
    image: "/ausbildung-it.png",
    availability: "soon",
    action: "interest",
    en: { title: "IT", description: "Vocational training in information technology, systems, and software." },
    de: { title: "IT", description: "Ausbildung in Informationstechnologie, Systemen und Software." },
    ar: { title: "تكنولوجيا المعلومات", description: "تدريب مهني في تكنولوجيا المعلومات والأنظمة والبرمجيات." },
  },
  "Erzieher:in": {
    image: "/ausbildung-erzieher.png",
    availability: "soon",
    action: "apply",
    en: { title: "Early childhood education", description: "Vocational training in education and supporting children’s development." },
    de: { title: "Erzieher:in", description: "Ausbildung in Pädagogik und in der Begleitung der kindlichen Entwicklung." },
    ar: { title: "التربية ورعاية الأطفال", description: "تدريب مهني في التربية ودعم نمو الأطفال." },
  },
};
